import styled, { css } from 'styled-components'
import { StyledGlobalMainContainer } from '../globalStyle'

// const ScaleIn = keyframes`
//   0% {
//     transform: scale(1);
//   }
//   50% {
//     transform: scale(1.02);
//   }
//   100% {
//     transform: scale(1);
//   }
// `

export const StyledContainer = styled(StyledGlobalMainContainer)`
	margin-top: 76px;
	display: block;
`

export const StyledTitleContainer = styled.div`
	display: grid;
	justify-items: center;
	grid-row-gap: 32px;
	h1 {
		text-align: start;
	}
`

export const StyledDescription = styled.div`
	margin-top: 41px;
	display: grid;
	justify-items: center;
	align-items: center;
`

export const StyledMainContainer = styled.div`
	display: grid;
	grid-column-gap: 91px;
`

export const StyledGroupInner = styled.div`
	display: grid;
	grid-row-gap: 16px;
	grid-auto-rows: max-content;
	min-height: 532px;
	max-height: 532px;
	overflow: scroll;
	padding: 32px 65px 32px 45px;
	background: #ffffff;
	box-shadow: 0 10px 34px rgba(191, 196, 202, 0.3);
	border-radius: 8px;
`

export const StyledInnerContainer = styled.div`
	display: grid;
	margin-top: 51px;
	align-items: center;
	justify-items: center;
	transition: all ease 0.8s;
	@media (max-width: 768px) {
		padding: 0;
		grid-template-columns: 1fr;
		grid-row-gap: 69px;
		margin-top: 59px;
		display: none;
	}
	@media (max-width: 576px) {
		padding: 0;
		grid-template-columns: 1fr;
		grid-row-gap: 69px;
		margin-top: 49px;
	}
`

export const StyledInnerSideBar = styled.ul`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: 118px;
	@media (max-width: 768px) {
		padding: 0;
		grid-template-columns: 1fr;
		grid-row-gap: 69px;
		margin-top: 59px;
		display: none;
	}
	@media (max-width: 576px) {
		padding: 0;
		grid-template-columns: 1fr;
		grid-row-gap: 69px;
		margin-top: 49px;
	}
`
export const StyledInnerImageContainer = styled.div`
	transition: all 1s ease;
	position: relative;
	width: 963px;
	height: 676px;

	svg {
		position: absolute;
		width: 100%;
		height: 100%;
		${({ animation }) =>
			!animation &&
			`
        -webkit-transition:  .5s ease-in-out;
    -moz-transition:  .5s ease-in-out;
    -o-transition:  .5s ease-in-out;
    transition:  .5s ease-in-out;
    
    `}
		${({ animation }) =>
			animation &&
			css`
				opacity: 0.8;
			`}
	}
`

export const StyledLi = styled.li`
	font-size: 16px;
	line-height: 30px;
	color: #000000;
	font-weight: 500;
	transition: ease 0.8s;
	cursor: pointer;
	padding: 8px 20px;
	margin-right: 10px;
	border-radius: 28px;
	text-transform: capitalize;
	${({ active }) =>
		active &&
		`
    color: #FFFFFF;
    background: rgb(0, 104, 255);
  `};
`

export const StyledMobileContainer = styled.div`
	display: block;
`

export const StyledLogoContainer = styled.div`
	width: 200px;
	min-height: 65px;
	position: relative;
	img {
		position: absolute;
		width: 100%;
		height: 100%;
	}
`

export const StyledDescriptionContainer = styled.p`
	font-weight: 500;
	font-size: 16px;
	line-height: 34px;
	color: #264445;
`
export const StyledEffectDescription = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 34px;
	color: #264445;
`

export const StyledInnerTitle = styled.span`
	font-size: 18px;
	line-height: 30px;
	font-weight: bold;
	text-transform: uppercase;
	color: #264445;
	display: block;
`

export const StyledHeaderDescription = styled.p`
	justify-self: center;
	font-size: 18px;
	line-height: 30px;
	text-align: center;
	font-weight: 500;
	color: #797a80;
	max-width: 432px;
	margin-top: 51px;
`
